import { denormalize } from "@/helpers/JsonApiDenormalizer";
import { ContractService } from "@/services/contract.service";

const contracts = {
  namespaced: true,
  state: {
    contracts: [],
    selected_contract_id: null,
  },
  getters: {
    selected: (state) => {
      const contract = state.contracts.find(c => {
        return c.id == state.selected_contract_id;
      });
      return contract;
    },
  },
  mutations: {
    SET_CONTRACTS(state, contracts) {
      state.contracts = Array.isArray(contracts) ? contracts : [];
    },
    SET_SELECTED_CONTRACT(state, contract_id) {
      state.selected_contract_id = contract_id || null;
    },
  },
  actions: {
    selectContract({ commit }, contract) {
      let contract_id = null;
      if (contract !== null) {
        contract_id = (typeof contract === 'object')
          ? parseInt(contract.id, 10)
          : parseInt(contract, 10);
      }
      commit('SET_SELECTED_CONTRACT', contract_id);
    },
    async fetchContracts({ commit, rootState }) {
      try {
        const contracts = await ContractService.all().then(response => denormalize(response.data));
        commit('SET_CONTRACTS', contracts);
        return contracts;
      } catch (err) {
        throw err;
      }
    },
  },
};

export default contracts;
